import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Suspense as _Suspense, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "logo2" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "flex-center",
  style: {"flex-direction":"column"}
}
const _hoisted_4 = ["src"]

import { ref, watch } from 'vue';
import Modal from '@/components/Modal/Index.vue';
import { originObj } from '@/config/index';
import selfRouter from './route';
import { hideLogin } from '.';


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {



const { lastonePage } = selfRouter
const show = ref(true)
watch(show, (newVal) => {
    if (!newVal) {
        hideLogin()
    }
})




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    selfRouter: _unref(selfRouter),
    modelValue: show.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: _unref(originObj)?.logo?.login || '',
          alt: ""
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("div", null, [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(lastonePage).component), {
              params: _unref(lastonePage).params
            }, null, 8, ["params"]))
          ]),
          fallback: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                class: "loading m-t-40 m-b-40",
                src: require('@/assets/img/loading.gif'),
                alt: ""
              }, null, 8, _hoisted_4),
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "loading...", -1))
            ])
          ]),
          _: 1
        }))
      ])
    ]),
    _: 1
  }, 8, ["selfRouter", "modelValue"]))
}
}

})